import { Component, Input, OnInit } from '@angular/core';
import { faPlus, faTimes, faExternalLink, faShare, faPencil } from '@fortawesome/pro-light-svg-icons';
import { InvoiceService } from '../../../../shared/services/invoice.service';
import { InvoiceComponent } from '../invoice/invoice.component';
import { AddInvoiceComponent } from '../add-invoice/add-invoice.component';
import { Subscription } from 'rxjs';
import { KlyantService } from '../../../../shared/services/klyant.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalService } from 'src/app/shared/services/modal.service';
import { YesNoPopupComponent } from 'src/app/shared/components/yes-no-popup/yes-no-popup.component';
import { ToastService } from 'src/app/shared/services/toast.service';


@Component({
  selector: 'app-invoice-list',
  templateUrl: './invoice-list.component.html',
  styleUrls: ['./invoice-list.component.scss']
})
export class InvoiceListComponent implements OnInit {

  @Input() caseId : number;
  @Input() caseTypeId : number;

  invoices: any[] = []; 

  faPlus = faPlus;
  faTimes = faTimes;
  faShare = faShare;
  faPencil = faPencil;
  faExternalLink = faExternalLink;

  reloadInvoicesSubscription: Subscription;

  constructor(
    private invoiceService: InvoiceService,
    private klyantService: KlyantService,
    private toastService: ToastService,
    public modalService: ModalService,
    public activeModal: NgbActiveModal) { 

    }

  ngOnInit(): void {
    this.loadInvoices();
  }

  loadInvoices(){
    this.invoiceService.getInvoices(this.caseId).subscribe((response : any) => {
      console.log(response);
      this.invoices = response.invoices;
    });
  }

  editInKlyant(invoiceId: number) {
    //window.open(environment.klyant.guiBaseUrl + '/invoices/' + invoiceId + '/edit', '_blank'); ?? what link?
    alert('TODO - work out which link to use');
  }


  archiveInvoice(invoiceId: number, klyantInvoiceId: number) {

    var popupText = '';
    if(klyantInvoiceId)
    {
      popupText = 'THIS INVOICE HAS BEEN SENT TO KLYANT. YOU MUST ALSO VOID IN KLYANT';
    }

    const modalRef = this.modalService.openWithOptions(YesNoPopupComponent, { size: 'lg'});
                  
    modalRef.componentInstance.messageHeader = 'Are you sure you want to archive this invoice?';
    modalRef.componentInstance.popupText1 = popupText;

    modalRef.result.then(
      (result) => {
        if (result) {
           this.invoiceService.archiveInvoice(this.caseId,invoiceId).subscribe((response : any) => {
          this.loadInvoices();
        });  
        }
    },
      () => {} // dismissed - do nothing
    );
   
  }


  openInvoice(invoiceId: number){


    const modalRef = this.modalService.openWithOptions(InvoiceComponent, { windowClass: 'modal-xxl' });
                    
    modalRef.componentInstance.caseId = this.caseId;
    modalRef.componentInstance.invoiceId = invoiceId;
    modalRef.componentInstance.caseTypeId = this.caseTypeId;

    modalRef.result.then(
    (result) => {
      this.loadInvoices();
      },
      () => {} // dismissed - do nothing
    );
  }

  addInvoice(){
    if(this.caseTypeId == 1 || // Equity Release
      this.caseTypeId == 6 || // Conveyancing Sale
      this.caseTypeId == 7 || // Equity Release Including Purchase
      this.caseTypeId == 8)	// Conveyancing Purchase
    {
      this.invoiceService.getInvoices(this.caseId).subscribe((response : any) => {
        var invoices = response.invoices;
        if(invoices.length == 0){

            const modalRef = this.modalService.openWithOptions(YesNoPopupComponent, { size: 'lg'});
                  
            modalRef.componentInstance.messageHeader = 'Are all property details completed?';

            modalRef.result.then(
              (result) => {
                if (result) {
                  this.openAddInvoice();
                }
            },
            () => {} // dismissed - do nothing
          );
        }
        else{
          this.openAddInvoice();
        }
  
      });
    }
    else{
      this.openAddInvoice();
    }
  }

  openAddInvoice(){

     const modalRef = this.modalService.openWithOptions(AddInvoiceComponent, { size: 'md'});
                  
      modalRef.componentInstance.caseId = this.caseId;

      modalRef.result.then(
        (result) => {
          if(result > 0)
          {
            this.openInvoice(result);
            this.loadInvoices();
          }
      },
      () => {} // dismissed - do nothing
    );
  }


  sendToKlyant(invoice: any)
  {
      const modalRef = this.modalService.openWithOptions(YesNoPopupComponent, { size: 'lg' });
                  
      modalRef.componentInstance.messageHeader = 'Are you sure you want to send the invoice to Klyant?';
      modalRef.componentInstance.popupText1 = 'THE INVOICE WILL NOT BE EDITABLE IN THE PORTAL ONCE SENT TO KLYANT'

      modalRef.result.then(
        (result) => {
          if (result) {
            
        invoice.sendingToClient = true;
        this.klyantService.sendInvoiceToKlyant(this.caseId, invoice.id).subscribe((response) => {
          this.toastService.success("Invoice Saved to Klyant");
          this.loadInvoices();
        }, (error: any) => {      
            this.toastService.error(error.error);
            invoice.sendingToClient = false;      
        });
    }},
      () => {} // dismissed - do nothing
    );
  }

}
